"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContainer = void 0;
exports.mapDispatchToProps = mapDispatchToProps;
exports.mapStateToProps = mapStateToProps;
exports.mergeProps = mergeProps;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _reactRedux = require("react-redux");
var _ConfirmationCallCodeFormController = require("../../../../components/ConfirmationCallCodeFormController");
var _tracking = require("../../../../utils/tracking");
var _authentication = require("../../../../actions/authentication");
var _twoFactorPhone = require("../../../../actions/twoFactorPhone");
var _selectors = require("./selectors");
var _source = require("../../../../selectors/source");
const _excluded = ["onVerify"],
  _excluded2 = ["phone"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function mapStateToProps(state) {
  return {
    sendValidationCodeStatus: (0, _selectors.sendValidationCodeStatusSelector)(state),
    phone: (0, _selectors.phoneSelector)(state),
    isSubmitting: (0, _selectors.isSubmittingSelector)(state),
    hasCodeError: (0, _selectors.hasAuthErrorSelector)(state),
    codeError: (0, _selectors.authErrorSelector)(state),
    codeTimeout: (0, _selectors.resendTimeoutSelector)(state),
    source: (0, _source.sourceSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    onResendCode() {
      (0, _tracking.trackPhoneAuthResendCodeClick)();
      dispatch((0, _twoFactorPhone.sendCodeMultichannel)());
    },
    onVerify(code, phone) {
      dispatch((0, _authentication.authenticate)({
        code,
        phone
      }));
    },
    onCodeCleared() {
      (0, _tracking.trackPhoneAuthCallReEnterButtonClick)();
    }
  };
}
function mergeProps(stateProps, dispatchProps) {
  const {
      onVerify
    } = dispatchProps,
    restDispatchProps = (0, _objectWithoutProperties2.default)(dispatchProps, _excluded);
  const {
      phone
    } = stateProps,
    restStateProps = (0, _objectWithoutProperties2.default)(stateProps, _excluded2);
  return _objectSpread(_objectSpread(_objectSpread({}, restStateProps), restDispatchProps), {}, {
    onVerify(code) {
      onVerify(code, phone);
    }
  });
}
const FormContainer = exports.FormContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps)(_ConfirmationCallCodeFormController.ConfirmationCallCodeFormController);